import {ajaxV2} from '../../helpers';

export const setGameStatus = (game, status) => {
  return ajaxV2
    .post(`/${game}/save_progress`, status)
    .catch(err => {
      window.devMode && console.log('setPersonStatus error: ', err)
    })
};
